(() => {
  // A response document in our submission frame must never initialize another
  // waiting list or emit another set of analytics events.
  if (window.name.startsWith('da-submit-')) return;
  const GUIDES = {
    polo: {
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      note: 'Polo oversize. Misure in centimetri.',
      headers: ['Taglia', 'Torace', 'Lunghezza', 'Manica'],
      rows: [['XS','54','59','70'],['S','56','61','72'],['M','58','63','74'],['L','60','65','76'],['XL','62','67','78']]
    },
    longsleeve: {
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      note: 'Longsleeve boxy. Misure in centimetri.',
      headers: ['Taglia', 'Torace', 'Lunghezza', 'Manica'],
      rows: [['XS','56','65','70'],['S','58','67','72'],['M','60','69','74'],['L','62','71','76'],['XL','64','73','78']]
    },
    hoodie: {
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      note: 'Zip hoodie. Misure in centimetri.',
      headers: ['Taglia', 'Torace', 'Lunghezza', 'Manica'],
      rows: [['XS','58','57','78'],['S','60','59','80'],['M','62','61','82'],['L','65','64','85'],['XL','67','66','87']]
    },
    baggy: {
      sizes: ['XS / 28', 'S / 30', 'M / 32', 'L / 34', 'XL / 36'],
      note: 'Jeans baggy. Misure in centimetri.',
      headers: ['Taglia', 'Vita', 'Gamba', 'Fondo'],
      rows: [['XS / 28','34','95','26'],['S / 30','36','97','28'],['M / 32','38','99','30'],['L / 34','40','101','32'],['XL / 36','42','103','34']]
    },
    flare: {
      sizes: ['XS / 28', 'S / 30', 'M / 32', 'L / 34', 'XL / 36'],
      note: 'Jeans flare. Misure in centimetri.',
      headers: ['Taglia', 'Vita', 'Gamba', 'Fondo'],
      rows: [['XS / 28','32','95','32'],['S / 30','34','97','34'],['M / 32','36','99','36'],['L / 34','38','101','38'],['XL / 36','40','103','40']]
    }
  };

  class DolceAmaroWaitingList {
    constructor(root) {
      this.root = root;
      this.captchaReady = this.waitFor(() => window.Shopify?.captcha, 3000);
      this.state = { name: '', email: '', products: [], source: this.getSource(), signedUpAt: '' };
      this.busy = false;
      this.signupSaved = false;
      this.signupForm = root.querySelector('.da-waiting-list__form');
      this.fallbackForm = root.querySelector('.da-waiting-list__fallback-form');
      this.notice = root.querySelector('[data-da-notice]');
      this.progress = root.querySelector('[data-da-progress]');
      this.productButton = root.querySelector('[data-da-product-continue]');
      this.confirmButton = root.querySelector('[data-da-confirm]');
      this.bind();
      this.restoreSignupProgress();
      this.track('da_waitlist_view', { source: this.state.source });
    }

    bind() {
      this.signupForm?.addEventListener('submit', (event) => this.handleSignup(event));
      this.root.querySelectorAll('[data-da-product], [data-da-product-unknown]').forEach((input) => {
        input.addEventListener('change', () => this.updateSelection(input));
      });
      this.productButton?.addEventListener('click', () => this.handleProduct());
      this.confirmButton?.addEventListener('click', () => this.handleConfirm());
      this.root.querySelector('[data-da-back-to-products]')?.addEventListener('click', () => this.showStep(2));
      this.root.querySelector('[data-da-carousel-prev]')?.addEventListener('click', () => this.scrollCarousel(-1));
      this.root.querySelector('[data-da-carousel-next]')?.addEventListener('click', () => this.scrollCarousel(1));
      const dialog = this.root.querySelector('[data-da-password-dialog]');
      this.root.querySelector('[data-da-open-password]')?.addEventListener('click', () => dialog?.showModal());
      this.root.querySelector('[data-da-close-password]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      if (
  dialog?.querySelector('.da-waiting-list__password-error') &&
  !this.root.classList.contains('da-early-access')
) {
  dialog.showModal();
}
      this.updateSelection();
    }

    async handleSignup(event) {
      if (window.Shopify?.designMode) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.signupForm.reportValidity()) return;
        if (!this.signupForm.elements['contact[first_name]'].value.trim()) {
          this.showNotice('Inserisci il tuo nome.');
          return;
        }
        if (!this.root.querySelector('[data-da-editor-preview]')) {
          const banner = document.createElement('p');
          banner.setAttribute('data-da-editor-preview', '');
          banner.setAttribute('role', 'note');
          banner.style.cssText = 'padding:12px;margin:0 0 20px;border:1px solid #777;font-size:12px;line-height:1.5;';
          banner.textContent = 'MODALITÀ PROVA: nessuna iscrizione o preferenza viene inviata. Puoi provare prodotti e taglie.';
          this.notice.before(banner);
        }
        const success = this.root.querySelector('[data-da-step="4"]');
        success.querySelector('.da-waiting-list__step-label').textContent = 'SIMULAZIONE';
        success.querySelector('h2').textContent = 'Prova completata';
        success.querySelector('p:not(.da-waiting-list__step-label)').textContent = 'Hai completato il percorso di prova. Nessun contatto o preferenza è stato inviato da questa simulazione.';
        success.querySelector('small').textContent = 'Questa prova non verifica il salvataggio in Shopify né l’invio delle email.';
        this.editorPreviewStarted = true;
        this.showStep(2);
        return;
      }
      event.preventDefault();
      if (this.busy) return;
      this.clearNotice();
      if (!this.signupForm.reportValidity()) return;
      if (!this.signupForm.elements['contact[first_name]'].value.trim()) {
        this.showNotice('Inserisci il tuo nome.');
        return;
      }
      this.busy = true;
      const button = this.signupForm.querySelector('button[type="submit"]');
      this.setLoading(button, true);
      const formData = new FormData(this.signupForm);
      this.state.name = String(formData.get('contact[first_name]') || '').trim();
      this.state.email = String(formData.get('contact[email]') || '').trim();
      this.state.signedUpAt = new Date().toISOString();
      this.persistSignupProgress();
      try {
        const savedInForms = await this.submitShopifyForms('lead');
        if (!savedInForms) throw new Error('Shopify non ha confermato l’iscrizione. Riprova.');
        this.signupSaved = true;
        this.leadSyncPromise = this.syncDashboard('lead').catch(() => false);
        this.track('da_waitlist_signup', { source: this.state.source });
        this.showStep(2);
      } catch (error) {
        this.clearSignupProgress();
        this.showNotice(error.message || 'Shopify non ha confermato l’iscrizione. Riprova.');
      } finally {
        this.busy = false;
        this.setLoading(button, false);
      }
    }

    updateSelection(changed) {
      const unknown = this.root.querySelector('[data-da-product-unknown]');
      const inputs = [...this.root.querySelectorAll('[data-da-product]')];
      if (changed === unknown && unknown.checked) inputs.forEach(input => { input.checked = false; });
      if (changed?.matches('[data-da-product]') && changed.checked) unknown.checked = false;
      let selected = inputs.filter(input => input.checked);
      if (selected.length > 3 && changed) {
        changed.checked = false;
        selected = inputs.filter(input => input.checked);
      }
      inputs.forEach(input => { input.disabled = selected.length === 3 && !input.checked; });
      this.productButton.disabled = !selected.length && !unknown.checked;
      this.root.querySelector('[data-da-selection-count]').textContent = selected.length === 3
        ? '3 di 3 selezionati · Deseleziona un pezzo per cambiarlo'
        : `${selected.length} di 3 prodotti selezionati`;
      // Keep a size only while its corresponding product remains selected.
      this.state.products = selected.map(input => ({
        sku: input.value,
        name: input.dataset.productName,
        group: input.dataset.sizeGroup || 'polo',
        size: this.state.products.find(product => product.sku === input.value)?.size || ''
      }));
      this.clearNotice();
    }

    async handleProduct() {
      if (this.busy) return;
      this.updateSelection();
      this.clearNotice();
      if (this.root.querySelector('[data-da-product-unknown]').checked) {
        await this.complete(this.productButton);
        return;
      }
      if (!this.state.products.length || this.state.products.length > 3) return;
      this.track('da_waitlist_product_selected', { product_skus: this.state.products.map(product => product.sku), product_count: this.state.products.length });
      this.renderSizes();
      this.showStep(3);
    }

    renderSizes() {
      const container = this.root.querySelector('[data-da-size-groups]');
      container.innerHTML = this.state.products.map((product, index) => {
        const guide = GUIDES[product.group] || GUIDES.polo;
        const name = `da-size-${this.root.dataset.sectionId}-${index}`;
        const choices = guide.sizes.map(size => `<label class="da-size-option"><input type="radio" name="${name}" value="${this.escape(size)}" ${product.size === size ? 'checked' : ''}><span>${this.escape(size)}</span></label>`).join('');
        const heads = guide.headers.map(value => `<th scope="col">${this.escape(value)}</th>`).join('');
        const rows = guide.rows.map(row => `<tr>${row.map((value, i) => i ? `<td>${this.escape(value)}</td>` : `<th scope="row">${this.escape(value)}</th>`).join('')}</tr>`).join('');
        return `<div class="da-size-group" data-da-size-group="${index}">
          <fieldset class="da-waiting-list__fieldset">
            <legend class="da-size-group__title">${index + 1}. ${this.escape(product.name)}<small>${this.escape(product.sku)}</small></legend>
            <div class="da-waiting-list__sizes">${choices}</div>
            <label class="da-waiting-list__unknown da-waiting-list__unknown--size"><input type="radio" name="${name}" value="Non lo so ancora" ${product.size === 'Non lo so ancora' ? 'checked' : ''}><span>Non lo so ancora</span></label>
          </fieldset>
          <details class="da-waiting-list__guide"><summary>Guida taglie</summary><div data-da-size-guide-content><p>${this.escape(guide.note)}</p><table><thead><tr>${heads}</tr></thead><tbody>${rows}</tbody></table></div></details>
        </div>`;
      }).join('');
      container.querySelectorAll('input').forEach(input => input.addEventListener('change', () => {
        const index = Number(input.closest('[data-da-size-group]').dataset.daSizeGroup);
        this.state.products[index].size = input.value;
        this.clearNotice();
      }));
    }

    async handleConfirm() {
      if (this.busy) return;
      const missing = this.state.products.find(product => !product.size);
      if (missing) {
        this.showNotice(`Scegli una taglia per ${missing.name}, oppure “Non lo so ancora”.`);
        return;
      }
      await this.complete(this.confirmButton);
    }

    async complete(button) {
      if (window.Shopify?.designMode) {
        if (!this.editorPreviewStarted) return;
        this.showStep(4);
        return;
      }
      if (this.busy || !this.signupSaved) return;
      this.busy = true;
      this.clearNotice();
      this.setLoading(button, true);
      this.lockChoices(true);
      try {
        await this.leadSyncPromise;
let savedInDashboard = false;
        try { savedInDashboard = await this.syncDashboard('complete'); } catch (_) { /* Preserve the contact-form fallback below. */ }
        if (!savedInDashboard) await this.submitFallback();
        this.track('da_waitlist_completed', {
          product_skus: this.state.products.map(product => product.sku),
          product_sizes: this.state.products.map(product => `${product.sku}:${product.size}`),
          product_count: this.state.products.length,
          source: this.state.source,
          destination: savedInDashboard ? 'waiting_list_dashboard' : 'shop_contact_email'
        });
        this.showStep(4);
        this.clearSignupProgress();
      } catch (error) {
        this.showNotice(`L’iscrizione è confermata. Le preferenze non sono ancora confermate: ${error.message || 'riprova tra poco.'}`);
      } finally {
        this.busy = false;
        this.lockChoices(false);
        this.setLoading(button, false);
      }
    }

    lockChoices(locked) {
      this.root.querySelectorAll('[data-da-step="2"] input, [data-da-step="3"] input, [data-da-back-to-products]').forEach(input => {
        if (locked) { input.dataset.daWasDisabled = String(input.disabled); input.disabled = true; }
        else { input.disabled = input.dataset.daWasDisabled === 'true'; delete input.dataset.daWasDisabled; }
      });
    }

    preferenceValues() {
      const products = this.state.products;
      return {
        product: products.length ? products.map(product => `${product.name} (${product.sku})`).join(' | ') : 'Non lo so ancora',
        size: products.length ? products.map(product => `${product.sku}: ${product.size}`).join(' | ') : 'Non lo so ancora'
      };
    }

    async submitShopifyForms(stage = 'complete') {
      const host = this.root.querySelector('[data-da-native-form]');
      if (!host) return false;
      const form = await this.waitFor(() => this.deepFind(host, 'form'), 2500);
      if (!form) return false;
      const preferences = stage === 'lead'
        ? { product: 'Da completare', size: 'Da completare' }
        : this.preferenceValues();
      const values = {
        Nome: this.state.name,
        Email: this.state.email,
        'Prodotto interessato': preferences.product,
        'Taglia interessata': preferences.size,
        Source: this.state.source
      };
      if (!Object.entries(values).every(([label, value]) => this.fillByLabel(form, label, value))) return false;
      // Do not invent consent by checking unrelated app checkboxes.
      if (!form.checkValidity()) return false;
      const submit = this.deepFind(form, 'button[type="submit"], input[type="submit"]');
      if (!submit) return false;
      const successText = (this.root.dataset.nativeSuccessText || 'Preferenze salvate').toLowerCase();
      const hasSuccess = () => this.deepFindAll(host, '*').some(node =>
        node.children.length === 0 && node.getClientRects().length > 0 &&
        !node.closest('script, style, template, [hidden]') &&
        (node.textContent || '').trim().toLowerCase() === successText);
      if (hasSuccess()) return false;
      const bridge = this.root.querySelector('[data-da-native-bridge]');
      const frame = document.createElement('iframe');
      const originalTarget = form.getAttribute('target');
      const originalSubmitTarget = submit.getAttribute('formtarget');
      let frameFinished = false;
      let frameError = '';
      frame.name = `da-submit-forms-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      frame.title = 'Invio iscrizione a Shopify';
      frame.className = 'da-waiting-list__submit-frame';
      frame.addEventListener('load', () => {
        try {
          const doc = frame.contentDocument;
          if (!doc || doc.location.href === 'about:blank') return;
          const path = new URL(doc.location.href).pathname;
          if (/\/challenge\/?$/.test(path) || doc.querySelector('form[action*="/challenge"]')) {
            frameError = 'Shopify richiede una verifica. Ricarica la pagina e riprova.';
            return;
          }
          frameFinished = true;
        } catch (_) {
          frameFinished = true;
        }
      });
      bridge.classList.add('is-submitting');
      bridge.appendChild(frame);
      form.setAttribute('target', frame.name);
      submit.setAttribute('formtarget', frame.name);
      const send = () => {
  if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
  else submit.click();
};
const captcha = window.Shopify?.captcha || await this.captchaReady;
if (typeof captcha?.protect === 'function') captcha.protect(form, send);
else send();
      const result = await this.waitFor(() => {
        if (frameError) return { error: frameError };
        if (hasSuccess() || frameFinished) return { success: true };
        return null;
      }, 12000);
      if (originalTarget === null) form.removeAttribute('target');
      else form.setAttribute('target', originalTarget);
      if (originalSubmitTarget === null) submit.removeAttribute('formtarget');
      else submit.setAttribute('formtarget', originalSubmitTarget);
      bridge.classList.remove('is-submitting');
      frame.remove();
      if (result?.error) throw new Error(result.error);
      return result?.success === true;
    }

    persistSignupProgress() {
      try {
        sessionStorage.setItem('da-waitlist-signup', JSON.stringify({
          name: this.state.name,
          email: this.state.email,
          signedUpAt: this.state.signedUpAt,
          savedAt: Date.now()
        }));
      } catch (_) { /* Storage is only a navigation fallback. */ }
    }

    restoreSignupProgress() {
      if (window.Shopify?.designMode) return;
      try {
        const raw = sessionStorage.getItem('da-waitlist-signup');
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (!saved?.email || !saved?.name || Date.now() - Number(saved.savedAt || 0) > 30 * 60 * 1000) {
          sessionStorage.removeItem('da-waitlist-signup');
          return;
        }
        this.state.name = String(saved.name);
        this.state.email = String(saved.email);
        this.state.signedUpAt = String(saved.signedUpAt || new Date().toISOString());
        this.signupSaved = true;
        window.setTimeout(() => this.showStep(2), 0);
      } catch (_) {
        sessionStorage.removeItem('da-waitlist-signup');
      }
    }

    clearSignupProgress() {
      try { sessionStorage.removeItem('da-waitlist-signup'); } catch (_) {}
    }

    async syncDashboard(stage) {
      const endpoint = String(this.root.dataset.dashboardEndpoint || '').trim();
      if (!endpoint) return false;
      const preferences = this.preferenceValues();
      const response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          name: this.state.name,
          email: this.state.email,
          product: stage === 'complete' ? preferences.product : '',
          size: stage === 'complete' ? preferences.size : '',
          source: this.state.source,
          signedUpAt: this.state.signedUpAt,
          stage,
          website: ''
        })
      });
      if (!response.ok) throw new Error('Dashboard non disponibile.');
      const payload = await response.json().catch(() => ({}));
      return payload.ok === true;
    }

    async submitFallback() {
      if (!this.fallbackForm) throw new Error('Modulo preferenze non disponibile.');
      const preferences = this.preferenceValues();
      const set = (selector, value) => { const input = this.fallbackForm.querySelector(selector); if (input) input.value = value; };
      set('[data-da-fallback-name]', this.state.name);
      set('[data-da-fallback-email]', this.state.email);
      set('[data-da-fallback-product]', preferences.product);
      set('[data-da-fallback-size]', preferences.size);
      set('[data-da-fallback-source]', this.state.source);
      set('[data-da-fallback-date]', this.state.signedUpAt);
      set('[data-da-fallback-body]', `DolceAmaro FW26\nNome: ${this.state.name}\nEmail: ${this.state.email}\nProdotti: ${preferences.product}\nTaglie per SKU: ${preferences.size}\nSource: ${this.state.source}\nIscrizione: ${this.state.signedUpAt}`);
      await this.submitNative(this.fallbackForm, 'contact');
      return true;
    }

    async submitNative(form, kind) {
      // Shopify's supported wrapper obtains the anti-spam token. Calling
      // HTMLFormElement.prototype.submit bypasses that wrapper and is unsafe here.
      const captcha = await this.waitFor(() => window.Shopify?.captcha, 3000);
      return new Promise((resolve, reject) => {
        const frame = document.createElement('iframe');
        frame.name = `da-submit-${kind}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        frame.title = 'Verifica e invio a Shopify';
        frame.className = 'da-waiting-list__response-frame';
        const verification = this.root.querySelector('[data-da-verification]');
        const mount = this.root.querySelector('[data-da-verification-frame]');
        const originalTarget = form.getAttribute('target');
        let settled = false;
        let submitted = false;
        let timeout;
        const finish = (error) => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          frame.removeEventListener('load', inspect);
          frame.remove();
          verification.hidden = true;
          if (originalTarget === null) form.removeAttribute('target');
          else form.setAttribute('target', originalTarget);
          if (error) reject(error); else resolve(true);
        };
        const exposeVerification = () => {
          verification.hidden = false;
          frame.tabIndex = 0;
          verification.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          clearTimeout(timeout);
          timeout = setTimeout(() => finish(new Error('La verifica non è stata completata. Riprova.')), 180000);
        };
        const inspect = () => {
          if (!submitted || settled) return;
          let doc;
          let url;
          try {
            doc = frame.contentDocument;
            if (!doc || doc.location.href === 'about:blank') return;
            url = new URL(doc.location.href);
          } catch (_) {
            finish(new Error('Impossibile verificare la risposta di Shopify. Apri la pagina fuori dall’editor e riprova.'));
            return;
          }
          // A 200 response, a load event, or a generic password page does NOT
          // establish success. Require Shopify's rendered form outcome.
          const result = doc.querySelector(`[data-da-result="${kind}"]`);
          if (result?.dataset.daResultState === 'error') {
            finish(new Error(result.textContent.trim().slice(0, 220) || 'Shopify ha rifiutato i dati.'));
          } else if (result?.dataset.daResultState === 'success') {
            finish();
          } else if (/\/challenge\/?$/.test(url.pathname) || doc.querySelector('form[action*="/challenge"]')) {
            exposeVerification();
          } else {
            finish(new Error('Shopify non ha restituito una conferma di salvataggio. Riprova dalla pagina di anteprima.'));
          }
        };
        frame.addEventListener('load', inspect);
        mount.replaceChildren(frame);
        form.setAttribute('target', frame.name);
        // Preserve only the theme preview selector; never carry a stale success
        // query parameter into a subsequent response.
        const returnUrl = new URL(window.location.pathname, window.location.origin);
        const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewId) returnUrl.searchParams.set('preview_theme_id', previewId);
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = returnUrl.pathname + returnUrl.search;
        timeout = setTimeout(() => finish(new Error('Shopify non ha risposto in tempo. Verifica la connessione e riprova.')), 30000);
        const send = () => {
          if (settled || submitted) return;
          submitted = true;
          try { form.submit(); } catch (_) { finish(new Error('Invio a Shopify non riuscito. Riprova.')); }
        };
        try {
          if (typeof captcha?.protect === 'function') captcha.protect(form, send);
          else send();
        } catch (_) { finish(new Error('La verifica del modulo non è disponibile. Ricarica la pagina.')); }
      });
    }

    fillByLabel(root, wantedLabel, value) {
      const labels = this.deepFindAll(root, 'label');
      const normalizedWanted = wantedLabel.trim().toLowerCase();
      let field = null;
      for (const label of labels) {
        const text = (label.textContent || '').replace(/\*/g, '').trim().toLowerCase();
        if (text === normalizedWanted) {
          if (label.htmlFor) field = this.deepFind(root, `#${this.selectorEscape(label.htmlFor)}`);
          field ||= label.querySelector('input, textarea, select');
          if (field) break;
        }
      }
      if (!field) {
        const candidates = this.deepFindAll(root, 'input, textarea, select');
        field = candidates.find((input) => [input.name, input.placeholder, input.getAttribute('aria-label')].some((text) => (text || '').trim().toLowerCase() === normalizedWanted));
        if (!field && wantedLabel === 'Email') field = candidates.find(input => input.type === 'email');
        if (!field && wantedLabel === 'Nome') field = candidates.find(input => input.autocomplete === 'given-name');
      }
      if (!field) return false;
      const proto = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : field.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
      if (setter) setter.call(field, value); else field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      return true;
    }

    deepFind(root, selector) { return this.deepFindAll(root, selector)[0] || null; }
    deepFindAll(root, selector) {
      const found = [];
      const visit = (node) => {
        if (!node?.querySelectorAll) return;
        found.push(...node.querySelectorAll(selector));
        node.querySelectorAll('*').forEach((element) => { if (element.shadowRoot) visit(element.shadowRoot); });
      };
      visit(root);
      return found;
    }
    deepText(root) {
      let value = root?.textContent || '';
      root?.querySelectorAll?.('*').forEach((element) => { if (element.shadowRoot) value += ` ${this.deepText(element.shadowRoot)}`; });
      return value;
    }
    selectorEscape(value) { return window.CSS?.escape ? CSS.escape(value) : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&'); }
    waitFor(check, timeout) {
      return new Promise((resolve) => {
        const started = Date.now();
        const tick = () => {
          const result = check();
          if (result) return resolve(result);
          if (Date.now() - started >= timeout) return resolve(null);
          window.setTimeout(tick, 180);
        };
        tick();
      });
    }
    scrollCarousel(direction) {
      const carousel = this.root.querySelector('[data-da-carousel]');
      carousel?.scrollBy({ left: direction * carousel.clientWidth * .82, behavior: 'smooth' });
    }
    showStep(step) {
      this.clearNotice();
      this.root.querySelectorAll('[data-da-step]').forEach((panel) => { panel.hidden = Number(panel.dataset.daStep) !== step; });
      this.progress.style.width = step === 4 ? '100%' : `${Math.min(step, 3) * 33.333}%`;
      const heading = this.root.querySelector(`[data-da-step="${step}"] h2`);
      this.root.querySelector('.da-waiting-list__panel').scrollTop = 0;
      heading?.focus({ preventScroll: true });
      if (window.innerWidth < 900) this.root.querySelector('.da-waiting-list__panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setLoading(button, loading) {
      if (!button) return;
      button.disabled = loading;
      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', String(loading));
    }
    showNotice(message) { this.notice.textContent = message; this.notice.hidden = false; this.notice.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    clearNotice() { this.notice.hidden = true; this.notice.textContent = ''; }
    getSource() {
      const params = new URLSearchParams(window.location.search);
      const utm = ['utm_source','utm_medium','utm_campaign','utm_content'].map((key) => params.get(key)).filter(Boolean).join(' / ');
      if (utm) return utm.slice(0, 240);
      if (document.referrer) {
        try { return new URL(document.referrer).hostname.slice(0, 240); } catch (error) { return 'referral'; }
      }
      return 'direct';
    }
    track(eventName, data = {}) {
      if (window.Shopify?.designMode) return;
      if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' && !window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...data });
      const marketingAllowed = window.Shopify?.customerPrivacy?.marketingAllowed;
      if (typeof marketingAllowed === 'function' && !window.Shopify.customerPrivacy.marketingAllowed()) return;
      try {
        if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, data);
        if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track(eventName, data);
      } catch (_) { /* Analytics failure must not fail a saved form. */ }
    }
    escape(value) {
      return String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
    }
  }

  const init = (scope = document) => scope.querySelectorAll('[data-da-waiting-list]:not([data-da-ready])').forEach((root) => {
    root.dataset.daReady = 'true';
    new DolceAmaroWaitingList(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
